<template>
  <b-form-group
    label="Proje Talep Tarihi"
    label-for="pdate"
  >
    <validation-provider
      #default="{ errors }"
      name="Proje Talep Tarihi"
      rules="required"
    >
      <b-form-datepicker
        id="pdate"
        v-model="dataItem.pdate"
        v-bind="{labelNoDateSelected: 'Proje Talep Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
import { localize, ValidationProvider } from 'vee-validate'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ProjectsPDateCard',
  components: { ValidationProvider, BFormGroup, BFormDatepicker },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
